import { decodeJwt, DeliUser, TokenEvents, TokenManager, useMountedGetter, useAtomicTrigger } from '@lib/common';
import { filter, catchError, map} from 'rxjs/operators';
import * as userService from './user';
import * as auth from '@api/auth';
import { deliHistory } from '@global';
import { Cognito } from '@api/auth/cognito.types';
import Axios from 'axios-observable';
import { Permissions } from '@lib/common/user';
import { paramterize, pickResponse, pickResult } from '@api/utils';
export const token = new TokenManager();
import policy from '../lib/common/policies.json';
import { pintHttp } from '@api/client';
import { windowObj } from '@lib/common';

token.setLoginApi(auth.loginCognito);
token.setRefresher(auth.refreshCognitoToken);

const DELI_BASE_URL = windowObj.RAZZLE_VCMS_API_URL + '/v1';


fetch(`${DELI_BASE_URL}/data/deli`, {
  method: 'POST', // or 'PUT'
  headers: {
    'Content-Type': 'application/json',
    "Access-Control-Allow-Origin":"*"
  },
  body: JSON.stringify({}),
})
  .then((response) => response.json())
  .then((data) => {

  })
  .catch((error) => {
    console.error('Error:', error);
  });
  
const permissions = Axios.get<Permissions>(`${DELI_BASE_URL}/data/deli`, 
                  {headers: {"Content-Type": "application/json", "Access-Control-Allow-Origin":"*"}})
                  .pipe(pickResult())
  .pipe(
    map(res => ({
      ...res,
      data: res,
    }))
  )
  .subscribe({
    next: data => {
      console.log(data.data);
    },
    error: data => {
      console.log(data, 'Error');
    },
    complete: () => {
      console.log('complete');
    },
  });
token.event$.pipe(filter(evt => evt === TokenEvents.SET_TOKEN)).subscribe(() => {
  const user = decodeJwt<Cognito.IdentityPayload>(token.id);
  
  const roleId = user['custom:roleId'] ? user['custom:roleId'] : 'super_admin';

  const userRoles = roleId.split(",")

  
  // const userRoles = "DEAL_Auditor". split(',')
  var buttons_permission = [];
  var pages_permission = [];
  let policy_updated = policy.UI_Permissions;
  userRoles.map((role) => {
    const roleId = role.trim();
    if(policy.UI_Permissions[roleId] != null){
      buttons_permission = buttons_permission.concat(policy.UI_Permissions[roleId]['Button']);
      pages_permission = pages_permission.concat(policy.UI_Permissions[roleId]['pages']);
    }
  })
  
  const userPolicy = {"Button":buttons_permission, "pages": pages_permission};

  userService.setUser({
    vtr_id: user.email,
    designation: user['custom:designation'],
    first_name: user.name,
    last_name: user.family_name,
    organization: user['custom:organization'],
    username: user['cognito:username'],
    roleId: roleId,
    permissions:userPolicy
  });
});
// Logout user.
token.event$.pipe(filter(evt => evt === TokenEvents.CLEAR_TOKEN)).subscribe(() => {
  deliHistory.push('/login', { returnTo: deliHistory.location });
  userService.clearUser();
});

// Debug,
// token.event$.subscribe(evt => console.log(TokenEvents[evt]));

token.init();